import {IAnimationProps} from '@mintdata/mint-kit/api/animation/AnimationProps';
import {IAssetsProps} from '@mintdata/mint-kit/api/assets/IAssetsProps';
import {IFilesProps} from '@mintdata/mint-kit/api/file/IFilesProps';
import {CursorModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/cursor/CursorModel';
import {PageInfo} from '@mintdata/mint-kit/api/models/PageInfo';
import {Size} from '@mintdata/mint-kit/api/models/Size';
import {PropertyPanelTabId} from '@mintdata/mint-kit/api/properties/PropertyPanelTabId';
import {PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';
import {IReparentingProps} from '@mintdata/mint-kit/api/reparenting/IReparentingProps';

export class BaseProps
{
    size?:Size = null;
    autofocus?:boolean = false;
    isDraggable?:boolean = false;
    isThumbnailMode?:boolean = false;
    isDesignMode?:boolean = false;
    propertyPanelSelectedTabId?:PropertyPanelTabId;
    getPageInfo?:() => PageInfo;
    onLayoutUpdated?:() => void;
    surfaceAreaRef:HTMLElement | null;
    isPropBound:(propName:PropName, propPath:PropPath) => boolean;
    assets:IAssetsProps;
    files:IFilesProps;
    animation:IAnimationProps;
    reparenting?:IReparentingProps;
    cursor:CursorModel;
}
